import { Article } from "./types";

export const initialArticle: Article = {
  id: -1,
  title: "",
  metaDescription: "",
  metaTitle: "",
  slug: "",
  content: "",
  image: null,
  published: false,
  createdAt: new Date(),
  updatedAt: new Date(),
};
